/**
 * DeviceManager handles unique identification of the physical device/browser.
 * Since real MAC addresses are not accessible in JS, we use a persistent UUID.
 */
export default class DeviceManager {
    /**
     * Gets the unique device ID for this browser.
     * Generates one if it doesn't exist and persists it.
     * @returns {string} The unique device ID.
     */
    static getDeviceId() {
        let deviceId = localStorage.getItem('pixelblob_device_id') || localStorage.getItem('quicky_device_id');
        
        if (!deviceId) {
            // Generate a random ID that looks like a UUID
            deviceId = this.generateUUID();
            localStorage.setItem('pixelblob_device_id', deviceId);
            localStorage.setItem('quicky_device_id', deviceId);
        }
        
        return deviceId;
    }

    /**
     * Generates a technical fingerprint of the browser/device.
     * This is used as a fallback to identify the machine if localStorage is cleared.
     */
    static getFingerprint() {
        const parts = [
            navigator.platform,
            navigator.language,
            screen.width + "x" + screen.height,
            navigator.hardwareConcurrency || "0",
            Intl.DateTimeFormat().resolvedOptions().timeZone,
            // We use a simplified UserAgent (Major Browser version) to avoid fragility
            this.getSimplifiedUA()
        ];
        return parts.join("|");
    }

    static getSimplifiedUA() {
        const ua = navigator.userAgent;
        if (ua.includes("Firefox/")) return "Firefox";
        if (ua.includes("Edg/")) return "Edge";
        if (ua.includes("Chrome/")) return "Chrome";
        if (ua.includes("Safari/")) return "Safari";
        return "Unknown";
    }

    /**
     * Simple UUID v4 generator fallback
     */
    static generateUUID() {
        if (typeof crypto !== 'undefined' && crypto.randomUUID) {
            return crypto.randomUUID();
        }
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}
